export const ACTIVITY_FEED_TABS_KEYS = {
  comments: 'comments',
  commentsHistory: 'commentsHistory'
} as const
